<template>
  <v-col
    cols="12"
    lg="6"
    v-if="
      data.totale.maturato !== 0.0 ||
      data.totale.goduto !== 0.0 ||
      data.totale.residuo !== 0.0
    "
  >
    <v-row no-gutters class="mt-2">
      <v-col cols="12">
        <v-card flat tile
          ><div class="text-overline text-center title">
            {{ title }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3" class="head">
        <v-card outlined flat tile
          ><div class="text-center head">Anno</div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center head">Maturate</div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center head">Godute</div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center head">Residue</div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile class="px-1 text-truncate">
          Precedente
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ap.maturato | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ap.goduto | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ap.residuo | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile class="px-1 text-truncate">Corrente</v-card>
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ac.maturato | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ac.goduto | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.ac.residuo | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile class="px-1 text-truncate">Totale</v-card>
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.totale.maturato | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.totale.goduto | roundNumber }}
          </div></v-card
        >
      </v-col>
      <v-col cols="3">
        <v-card outlined flat tile
          ><div class="text-center">
            {{ data.totale.residuo | roundNumber }}
          </div></v-card
        >
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "detail-section",
  props: ["title", "data"],
};
</script>

<style></style>
